import { render, staticRenderFns } from "./StoreBusinessImage.vue?vue&type=template&id=6b301882&scoped=true"
import script from "./StoreBusinessImage.vue?vue&type=script&lang=js"
export * from "./StoreBusinessImage.vue?vue&type=script&lang=js"
import style0 from "./StoreBusinessImage.vue?vue&type=style&index=0&id=6b301882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b301882",
  null
  
)

export default component.exports